module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// external "undefined"
// module id = 789
// module chunks = 0